import template from './laborRateModal.html';
import controller from './laborRateModal.controller';

let LaborRateModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'md',
  windowClass: "hmodal-info animated zoomIn"
};

export default LaborRateModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/laborRateModal/laborRateModal.component.js